import type { FC } from "react";
import { SWReactIcons } from "@similarweb/icons";
import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";

interface IFavoritesCell {
    value: boolean;
}

const { blue, carbon } = colorsPalettes;

const Icon = styled(SWReactIcons)<{ color: string }>`
    height: 20px;
    width: 20px;
    ${({ color }) => `
        path,  #inner, #outer {
            fill: ${color};
        }
    `}
`;

export const FavoritesCell: FC<IFavoritesCell> = (props) => {
    const { value: isFavorite } = props;
    return (
        <Icon
            color={isFavorite ? blue[400] : carbon[200]}
            iconName={isFavorite ? "star" : "star-outline"}
        />
    );
};
